import { Grid, TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { InitialValues } from "../../../pages/Storage/models/types";
import { Textarea } from "../../../pages/Storage/shared/Textarea";
import { styles } from "../../../pages/Storage/shared/styles";

interface FooterFieldsProps {
  formik: FormikProps<InitialValues>;
  isViewing: boolean;
}

export const FooterFields: React.FC<FooterFieldsProps> = ({
  formik,
  isViewing,
}) => (
  <>
    <Grid item>
      <Typography sx={{ mb: 0.5, fontWeight: 700 }} color="shadesOfDark.dark">
        Canal de distribuição
      </Typography>

      <TextField
        variant="outlined"
        size="small"
        value={formik.values.distributionChannel}
        // eslint-disable-next-line @typescript-eslint/promise-function-async
        onChange={(e) =>
          formik.setFieldValue("distributionChannel", e.target.value)
        }
        disabled={isViewing}
        sx={styles.textField}
      />
    </Grid>

    <Grid item xs={12}>
      <Typography color="shadesOfDark.dark" sx={styles.label}>
        Observação do cliente
      </Typography>

      <Textarea
        value={formik.values.note ?? "Nenhuma observação registrada."}
        disabled
        sx={styles.textField}
      />
    </Grid>
  </>
);
